import React from 'react';
import { hasReactChildren } from 'utils/ui';
import Box from 'components/Box';
import Flex from 'components/Flex';
import InlineList from 'components/InlineList';
export default function HeadingWithFilters(_ref) {
  var heading = _ref.heading,
    children = _ref.children;
  var hasFilters = hasReactChildren(children);
  return /*#__PURE__*/React.createElement(Flex, {
    flexDirection: ['column', 'row'],
    align: ['left', 'center'],
    breakpoints: "s",
    mb: "l"
  }, /*#__PURE__*/React.createElement(Box, {
    grow: true,
    shrink: true,
    breakpoints: "s",
    mb: ['m', 0],
    mr: hasFilters ? 'l' : undefined
  }, heading), hasFilters && /*#__PURE__*/React.createElement(InlineList, {
    spacing: "l",
    as: "div",
    itemAs: "div"
  }, children));
}